// eslint-disable-next-line
import { h } from 'preact';
import PropTypes from 'prop-types';

const IconDialogue = ({ fill, className, width, height }) => (
    <svg
        className={className}
        viewBox="0 0 50 50"
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill={fill}
            d="M39.433 50c-.515 0-.902-.129-1.289-.515l-5.283-6.96h-5.8c-1.417 0-2.576-.386-3.607-1.288-1.031-.773-1.547-1.804-1.547-2.964v-2.706l-3.866 4.897c-.386.387-.773.644-1.16.644-.257 0-.515 0-.644-.129-.644-.257-1.03-.773-1.03-1.546l.515-5.799H6.443c-1.804 0-3.35-.644-4.51-1.933C.644 30.541 0 28.995 0 27.32V6.314c0-1.675.644-3.221 1.933-4.51C3.093.644 4.639 0 6.443 0h24.871c1.805 0 3.35.644 4.64 1.804 1.16 1.289 1.804 2.835 1.804 4.51V22.81h7.216c1.418 0 2.578.387 3.608 1.16.903.902 1.418 1.933 1.418 3.093v11.211c0 1.16-.515 2.19-1.418 2.964-1.03.902-2.19 1.289-3.608 1.289h-2.706l-1.417 6.314c0 .645-.387 1.031-1.16 1.16h-.258zM6.443 3.093c-.902 0-1.675.258-2.32.902-.644.644-1.03 1.417-1.03 2.32V27.32c0 .902.386 1.546 1.03 2.19.645.645 1.418 1.031 2.32 1.031h10.954c.515 0 .902.13 1.16.516.257.257.386.644.386 1.16l-.129 2.32 3.093-3.996v-3.48c0-1.159.516-2.19 1.547-3.092 1.03-.773 2.19-1.16 3.608-1.16h7.603V6.314c0-.902-.258-1.675-.902-2.32-.644-.643-1.547-.901-2.449-.901H6.444zM25 27.062v11.211c0 .258.258.516.644.773.387.258.902.387 1.418.387h6.572c.515 0 .902.258 1.16.644l3.737 4.768.902-4.123c.129-.387.258-.645.515-.902.258-.258.645-.387 1.031-.387h3.995c.516 0 1.031-.129 1.418-.387.386-.257.515-.515.515-.773V27.062c0-.258-.129-.516-.515-.773-.387-.258-.902-.387-1.418-.387H27.062c-.516 0-1.031.129-1.418.387-.386.257-.644.515-.644.773zm6.443 6.185c-.386.387-.644.516-1.03.516-.387 0-.645-.129-1.032-.516-.257-.257-.386-.515-.386-.902 0-.386.129-.773.386-1.03.258-.258.645-.387 1.031-.387.387 0 .774.129 1.031.386.258.258.387.645.387 1.031 0 .387-.129.645-.387.902zm5.413 0c-.387.387-.645.516-1.031.516-.258 0-.516-.129-.902-.516-.387-.386-.516-.644-.516-.902 0-.386.13-.644.516-1.03.257-.258.515-.387.902-.387.386 0 .773.129 1.03.386.258.258.387.645.387 1.031 0 .387-.129.645-.386.902zm5.54 0c-.386.387-.643.516-1.03.516s-.644-.129-1.03-.516c-.259-.257-.388-.515-.388-.902 0-.386.13-.773.387-1.03.258-.258.644-.387 1.031-.387.387 0 .773.129 1.03.386.259.258.388.645.388 1.031 0 .387-.13.645-.387.902z"
        />
    </svg>
);

IconDialogue.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconDialogue.defaultProps = {
    fill: '#ffffff',
    className: '',
    width: 30,
    height: 30,
};

export default IconDialogue;
